(ns common.specs.activity
  (:require [clojure.spec.alpha :as s]

            [common.specs.universal]
            [common.specs.provider]
            [spec-tools.data-spec :as ds]))

(s/def :activity/provider :common.specs.provider/provider)

;; An activity group is a logical grouping of activities
;; This maps to the notion of something akin to a course catalog.
(s/def :activity-group/uuid :common/uuid)
(s/def :activity-group/owner-uuid :common/uuid)
(s/def :activity-group/title string?)


;; An activity session is the data corresponding to one learners
;; journey through an activity.
(s/def :activity-session/uuid :common/uuid)
(s/def :activity-session/owner-uuid :common/uuid)

(s/def :activity/plo-type #{"video" "pdf"})

(def ^:private common-keys
  #:activity{:allow-disabling-of-cbqs boolean?
             :allow-unmatched-graded-questions boolean?
             :cme-front-matter-enabled boolean?
             :cme-front-matter-url string?
             :combined-test boolean?
             :completion-threshold float?
             :cornerstone-config map?
             :created-at :common/date-time
             :description string?
             :evaluation {:questionnaire/uuid :common/uuid}
             :external-activity-link string?
             :future-scrubbing-enabled boolean?
             :looker any? ;;TODO
             :name string?
             :note-taking-enabled boolean?
             :plo-type :activity/plo-type
             :poster string?
             :published-on :common/date-time
             :ai-enabled boolean?
             :openai-assistant-id (ds/maybe string?)
             :questionnaires [{:questionnaire/uuid :common/uuid}]
             :show-all-moments boolean?
             :sign-in-display-name string?
             :sort-order number?
             :tile string?
             :updated-at :common/date-time})

(def db-item->activity-spec
  (ds/spec {:name ::db-item->activity
            :keys-default ds/opt
            :spec (merge common-keys)}))

(def activity->db-item-spec
  (ds/spec {:name ::activity->db-item
            :keys-default ds/opt
            :spec (merge common-keys
                         {(ds/req :activity/uuid) :common/uuid
                          :boosts [{:boost/uuid :common/uuid}]
                          :activity/curriculum {:curriculum/uuid :common/uuid}
                          :activity/pre-test {:questionnaire/uuid :common/uuid}
                          :activity/post-test {:questionnaire/uuid :common/uuid}
                          :activity/primary-learning-object {:resource/uuid :common/uuid}})}))
